<form #messageForm="ngForm" (ngSubmit)="sendMessage()" accept-charset="UTF-8">
    
    <app-doctors-list [multiple]="false" (doctorChange)="onDoctorChange($event)"></app-doctors-list>

    <div class="ui-g">
        <div class="ui-g-12">
            <button pButton type="button" label="Get Profile Link"  style="margin-left: 80%;"
            [disabled]="this.profileLinkAdded || this.message.to_user_guid==null || this.message.to_user_guid.length==0" (click)="getLink()"></button>
        </div>
    </div>


    <div class="ui-g-12">
        <div class="p-col">
            <label for="Subject">Subject</label><br>
            <input id="Subject" type="text" pInputText placeholder="Subject" style="width:50%;"
                [(ngModel)]="message.subject" name="subjectmodel" [maxlength]="max_subject_length"
                #subjectmodel="ngModel" [disabled]=" message_posting" required>
                <div class="ui-g-12" style="float: left;">
            <p [style.color]="message.subject.length-max_subject_length-1>0?'red':'green'" style="float: right;">
                {{(max_subject_length+1-message.subject.length)<0?0:max_subject_length-message.subject.length}}
                of {{max_subject_length}} characters left
            </p>
        </div>
            <div *ngIf="subjectmodel.invalid && (subjectmodel.dirty || subjectmodel.touched)"
                class="alert alert-danger">
                <div *ngIf="subjectmodel.errors.required">
                    Subject is required.
                </div>

            </div>
        </div>

    </div>

    <div class="ui-g-12">
        <div class="p-field p-grid">
            <textarea [rows]="5" [cols]="80" pInputTextarea [(ngModel)]="message.message" name="messagemodel"
                placeholder="Enter your message here" #messagemodel="ngModel" [maxlength]="max_message_length"
                [disabled]=" message_posting" required></textarea>
                <div class="ui-g-12" style="float: left;">  
            <p [style.color]="message.message.length-max_message_length-1>0?'red':'green'" style="float: right;">
                {{(max_message_length+1-message.message.length)<0?0:max_message_length-message.message.length}}
                of {{max_message_length}} characters left
            </p>
                </div>
            <div *ngIf="messagemodel.invalid && (messagemodel.dirty || messagemodel.touched)"
                class="alert alert-danger">
                <div *ngIf="messagemodel.errors.required">
                    Message is required.
                </div>

            </div>
        </div>

    </div>

    <div class="text-center compose-btn">
        <button pButton type="submit" label="Send" icon="fa fa-send m-l-5" style="margin-left: 80%;"
            [disabled]="!messageForm.valid || message_posting || this.message.message.trim().length==0"></button>
        <!-- <button pButton type="button" label="Discard" icon="fa fa-trash-o m-l-5"
            style="margin-left: 3%;"></button> -->
    </div>
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="message_posting" strokeWidth="6">
    </p-progressSpinner>
    <div *ngIf="message_response.success!=null && message_response.success==false" class="alert alert-danger">
        <p *ngIf="message_response.error!=null">{{message_response.error.message}}</p>
        <div *ngIf="message_serverError!=null">
            <div *ngIf="message_serverError.error!=null && message_serverError.statusCode!=500">
                <p *ngFor="let message of message_serverError.message">{{message}}</p>
            </div>
            <div *ngIf="message_serverError.error!=null && message_serverError.statusCode===500">
                <p>{{message_serverError.message}}</p>
            </div>
        </div>


    </div>
    <div *ngIf="message_response.success!=null && message_response.success==true" style="color: green;">
        <p>Your message has been sent</p>
    </div>
</form>
